import { IRatingProps, IUseRating } from "./rating.types";

export const useRating = (
  setScale: IRatingProps["setScale"],
  ratingClickCallback: IRatingProps["ratingClickCallback"]
): IUseRating => {
  const handleKeyPress = (
    e: React.KeyboardEvent<HTMLDivElement>,
    ratingValue: string
  ) => {
    if (e.key === " ") {
      handleRatingClick(ratingValue);
    }
  };
  const handleRatingClick = (ratingValue: string) => {
    setScale(ratingValue);
    if (ratingClickCallback) {
      ratingClickCallback();
    }
  };
  return {
    handleKeyPress,
    handleRatingClick
  };
};
